RivalIQ.apps.Registration.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Registration = Backbone.Model.extend({
        url: '/api/register',
        validate: function () {
            const me = this;
            const user = me.get('user');

            let errors = [];
            if (!user.isValid()) {
                errors = errors.concat(user.validationError);
            }

            return errors.length ? errors : null;
        },

        // TODO This model structure in this app could really use some rework
        toJSON: function () {
            const me = this;
            const companyIds = [];
            const user = me.get('user');
            const company = me.get('company');
            const landscape = me.get('landscape');


            // we need to filter out null id values that errored out to
            // prevent the server from exploding in scary ways
            landscape.forEach(function (domain) {
                const id = domain.get('id');

                if (id) {
                    companyIds.push(id);
                }
            });

            return {
                account: {
                    is_agency: (user.get('account').is_agency > 0),
                    lead_data: {
                        companyName: user.get('company_name'),
                        companyTitle: user.get('company_title')
                    },
                    name: user.get('company_name')
                },
                cloneLandscape: me.get('cloneLandscapeId') ? {
                    sourceLandscapeId: me.get('cloneLandscapeId')
                } : null,
                first_name: user.get('first_name'),
                last_name: user.get('last_name'),
                password: user.get('password'),
                company_id: company.get('id'),
                landscape: companyIds,
                landscapeName: me.get('landscapeName'),
                reportsToSchedule: me.get('reportsToSchedule'),
                userSettings: me.get('userSettings'),
                terms_and_conditions: user.get('terms_and_conditions')
            };
        }
    });
});
